<template>
  <m-dialog ref="dlg" @save="save">
    <v-row row wrap justify="center" align="center">
      <v-col cols="12" sm="10" md="10" lg="7" xl="7">
        <v-row>
          <v-card tile flat>
            <v-card-text>
              <v-form @submit.prevent data-vv-scope="form" lazy-validation>
                <v-row wrap>
                  <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                    <v-row wrap>
                      <v-col class="text-left title" cols="12" align-start colbox> Pilih Anggota</v-col>

                      <v-col cols="12" sm="12" md="12" lg="12" class="py-0">
                        <p class="error--text caption">Ketik 3 karakter dan tekan tombol enter untuk melakukan pencarian</p>
                        <v-autocomplete
                          dense
                          outlined
                          placeholder="Pilih Anggota"
                          :items="itemKandidats"
                          :search-input.sync="search"
                          v-model="pengurus.warga_id"
                          item-value="id"
                          item-text="nama"
                          height="100"
                          label="Anggota"
                          @keyup.enter="getKandidat(search)"
                          data-vv-name="anggota"
                          data-vv-as="Anggota"
                          v-validate="'required'"
                          :error-messages="errors.collect('form.anggota')"
                        >
                          <template slot="item" slot-scope="data">
                            <v-row class="ma-1">
                              <v-col cols="6"
                                ><strong class="orange--text">{{ data.item.nama }}</strong> <br />NIK: {{ data.item.nik }}</v-col
                              >
                              <v-col cols="6"
                                ><span class="green--text">{{ data.item.propinsi.keterangan }}</span> <br /><span class="blue--text">{{ data.item.kota.keterangan }}</span> <br />
                                {{ data.item.kecamatan.keterangan }} - {{ data.item.kelurahan.keterangan }}
                              </v-col>
                            </v-row>
                          </template>
                          <template slot="selection" slot-scope="data">
                            <v-row class="ma-1">
                              <v-col cols="6"
                                ><strong class="orange--text">{{ data.item.nama }}</strong> <br />NIK: <strong>{{ data.item.nik }}</strong></v-col
                              >
                              <v-col cols="6"
                                ><span class="green--text">{{ data.item.propinsi.keterangan }}</span> <br /><span class="blue--text">{{ data.item.kota.keterangan }}</span> <br />
                                {{ data.item.kecamatan.keterangan }} - {{ data.item.kelurahan.keterangan }}
                              </v-col>
                            </v-row>
                          </template>
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </v-card>
        </v-row>
      </v-col>
    </v-row>
  </m-dialog>
</template>

<script>
export default {
  components: {},
  $_veeValidate: {
    validator: "new"
  },

  data() {
    return {
      rend: 1,
      jabatan: {},
      search: null,
      kode: {
        wilayah_id: null,
        tingkat: null
      },
      edit: false,
      pengurus: {},

      defUser: {
        name: null,
        foto: null,
        ktp: null,
        email: "",
        no_hp: null,
        kelamin: "L"
      },
      itemJabatans: [],
      itemKandidats: []
    };
  },
  methods: {
    // eslint-disable-next-line
    open(obj, wilayah, tingkat, isEdit) {
      this.edit = isEdit == "ubah" ? true : false;
      if (isEdit) {
        this.pengurus.warga_id = obj.pejabat.warga.id;
      } else {
        this.pengurus.warga_id = null;
      }
      this.jabatan = obj;
      this.kode.wilayah = wilayah;
      this.kode.tingkat = tingkat;
      this.rend = this.rend + 1;
      this.$validator.reset();

      return this.$refs.dlg.open();
    },
    getJabatan() {
      return this.$store
        .dispatch("pengurus/getJabatan", {
          params: {
            wilayah_id: this.kode.wilayah,
            tingkat: this.kode.tingkat
          }
        })
        .then(res => {
          this.itemJabatans = res;
        })
        .catch(e => e);
    },
    getKandidat(val) {
      return this.$store
        .dispatch("pengurus/getKandidat", {
          params: { wilayah_id: this.kode.wilayah, tingkat: this.kode.tingkat, nama: val }
        })
        .then(res => {
          this.itemKandidats = res;
        })
        .catch(e => e);
    },

    // eslint-disable-next-line
    save() {
      this.$validator
        .validateAll("form")
        .then(res => {
          if (!res) return Promise.reject();
          return res;
        })
        .then(() => {
          this.pengurus.wilayah_id = this.kode.wilayah;
          this.pengurus.tingkat = this.kode.tingkat;
          this.pengurus.jabatan_id = this.jabatan.id;
          return this.$store.dispatch("pengurus/form", this.pengurus);
        })
        .then(res => {
          if (res.error) {
            this.$error("Data Anggota gagal diperbarui");
          } else {
            this.$info("Data Anggota berhasil ditambahkan");
            this.$refs.dlg.resolve();
            return res;
          }
        })
        .catch(e => e);
    }
  },
  watch: {
    "pengurus.propinsi_id": function(n) {
      this.getKota(n);
    },
    "pengurus.kota_id": function(m) {
      this.getKecamatan(m);
    },
    "pengurus.kecamatan_id": function(o) {
      this.getKelurahan(o);
    },
    selectedDate(n) {
      if (n) var dateFormat = n.split(".");
      this.pengurus.tanggal_lahir = dateFormat[2] + "-" + dateFormat[1] + "-" + dateFormat[0];
    }
  }
};
</script>

<style>
.avatar-cropper-close {
  display: none;
}
</style>
